<a id="wts-widget" *ngIf="isWhatsAppVisible()" class="wts-widget" [ngClass]="{'wts-widget-collapse': whatsCollapssed}" target="_blank"(click)="openWhatsApp();">
    <i class="fab fa-whatsapp icon"></i><span>{{ getWhatsAppText() }}</span>
</a>